document.addEventListener('DOMContentLoaded', () => {
  const desktopHover = window.matchMedia(
    '(min-width: 990px) and (hover: hover) and (pointer: fine)'
  );

  let closeTimer;

  const closeMenu = (details, delay = 550) => {
    clearTimeout(closeTimer);

    closeTimer = setTimeout(() => {
      details.removeAttribute('open');
    }, delay);
  };

  const initializeHoverMenus = () => {
    document
      .querySelectorAll('header-menu > details')
      .forEach((details) => {
        if (details.dataset.hoverInitialized === 'true') return;

        details.dataset.hoverInitialized = 'true';

        const submenu = details.querySelector('.header__submenu');

        details.addEventListener('mouseenter', () => {
          if (!desktopHover.matches) return;

          clearTimeout(closeTimer);

          document
            .querySelectorAll('header-menu > details[open]')
            .forEach((otherMenu) => {
              if (otherMenu !== details) {
                otherMenu.removeAttribute('open');
              }
            });

          details.setAttribute('open', '');
        });

        details.addEventListener('mouseleave', () => {
          if (!desktopHover.matches) return;

          closeMenu(details);
        });

        if (submenu) {
          submenu.addEventListener('mouseenter', () => {
            if (!desktopHover.matches) return;

            clearTimeout(closeTimer);
            details.setAttribute('open', '');
          });

          submenu.addEventListener('mouseleave', () => {
            if (!desktopHover.matches) return;

            closeMenu(details, 250);
          });
        }
      });
  };

  initializeHoverMenus();

  document.addEventListener('shopify:section:load', initializeHoverMenus);
});
